const cachedScripts = [];

export default function scriptLoader(src) {
  return new Promise((resolve, reject) => {
    if (cachedScripts.includes(src)) {
      return resolve();
    }

    const script = document.createElement('script');
    script.onload = function onLoad() {
      cachedScripts.push(src);
      resolve();
    };
    script.onerror = reject;
    script.async = true;
    script.src = src;

    if (document.currentScript) {
      document.currentScript.parentNode.insertBefore(
        script,
        document.currentScript
      );
    } else {
      (document.head || document.getElementsByTagName('head')[0]).appendChild(
        script
      );
    }
  });
}
